import React from "react";
import {
  Typography,
  Card,
  Space,
  Button,
  Grid, // <- added
} from "antd";
import { useNavigate } from "react-router-dom"; // <- added
import { HomeOutlined, CaretLeftOutlined } from "@ant-design/icons"; // <- added
const { Title, Text, Paragraph } = Typography;

// ── Component ──────────────────────────────────────────
const Dashboard = () => {
  const navigate = useNavigate(); // <- added
  const screens = Grid.useBreakpoint(); // <- added
  // screens.sm è true quando la viewport è >= sm; regola la logica come preferisci
  const cardWidth = screens.md ? "50vw" : "100%"; // usa "100%" su schermi >= sm, altrimenti 10vw
  const paddingwidth = screens.md ? "0px" : "25px"; // più padding su schermi più grandi

  const categorie = [
    "Respirazione",
    "Deglutizione",
    "Fonoarticolazione",
    "Linguaggio",
    "Voce",
    "Altro",
  ];
  return (
    <Space direction="vertical" size={24} style={{ width: "100%" }}>
      {/* ── Hero banner with orange background ── */}
      <div
        style={{
          background: "#fff",
          height: "100vh",
          //display: "flex",
        }}
      >
        <div
          style={{
            background: "linear-gradient(135deg, #f9b27fff, #ff8c00)",
            height: "100px",
            maxHeight: "100px",

            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            boxShadow: "0 4px 20px rgba(255, 106, 0, 0.3)",

            position: "relative", // <- added so the home button can be positioned left
          }}
        >
          <Button
            type="text"
            onClick={() => navigate("/")}
            icon={<CaretLeftOutlined />}
            aria-label="Home"
            style={{
              position: "absolute",
              left: 16,
              top: "50%",
              transform: "translateY(-50%)",
              color: "#fff",
              fontSize: 20,
            }}
          >
            {" "}
            Back{" "}
          </Button>
          {/* Left: title */}
          <div style={{ alignItems: "center", justifyContent: "center" }}>
            <Title
              level={1}
              style={{
                color: "#fff",
                //margin: 0,
                letterSpacing: "-0.4px",
              }}
            >
              PappaPiano
            </Title>
          </div>
        </div>

        <div
          style={{
            width: cardWidth,
            alignItems: "center",
            margin: "0 auto",
          }}
        >
          <Typography style={{ padding: paddingwidth }}>
            <Title style={{ textAlign: "center" }}>Il Progetto</Title>

            <img
              src="/assets/disegno2.png"
              alt="Illustrazione"
              style={{ width: "100%", marginBottom: 24 }}
            />
            <Paragraph>
              Benvenuti in PappaPiano.it! Siamo{" "}
              <span style={{ fontWeight: "bold" }}>Rebecca Longo</span>,
              studentessa al terzo anno di Logopedia e la dott.ssa{" "}
              <span style={{ fontWeight: "bold" }}>Alice Minuti</span>,
              Logopedista. <br />
              Questa piattaforma è stata ideata in seguito ad una riflessione
              rispetto alle difficoltà quotidiane, che i caregivers affrontano
              preparando i pasti per il proprio bambino/a con disfagia. Questo
              strumento vuole supportare la gestione dei pasti al di fuori del
              contesto ospedaliero-riabilitativo, attraverso la fruizione di
              video e piccoli consigli pratici. Questi si basano sulla
              letteratura scientifica e in particolare sulla scala IDDSI
              (Iniziativa Internazionale per la Standardizzazione della Dieta in
              Disfagia), che classifica in 7 livelli le consistenze di alimenti
              e bevande. Specificamente la scala descrive come si presenta la
              singola consistenza, fornisce esempi e spiega come assicurarsi di
              averla preparata correttamente. All’interno di PappaPiano.it,
              oltre ai video che spiegano come poter testare i livelli IDDSI,
              troverete anche consigli per l’assunzione di farmaci in sicurezza,
              infine dei suggerimenti per implementare e facilitare
              l’idratazione nel corso della giornata. Vi chiediamo gentilmente
              di compilare il questionario anonimo che trovate al link
              sottostante. In questo modo potrete lasciarci una vostra opinione
              in merito all’efficacia e utilità del sito, permettendoci di
              adattarlo alle vostre esigenze.
            </Paragraph>

            <Button
              type="primary"
              onClick={() =>
                window.open(
                  "https://qualtricsxmxyysfy4g9.qualtrics.com/jfe/form/SV_861jnR4LLiozBf8",
                  "_blank",
                )
              }
              style={{
                display: "block",
                margin: "0 auto",

                height: "48px",
              }}
            >
              Questionario
            </Button>
            <Paragraph style={{ marginTop: 24 }}>
              ‘This site is NOT the official IDDSI website’ and refer the
              visitors to www.IDDSI.org for the most current information and
              resources. Il framework e i descrittori IDDSI sono rilasciati
              sotto licenza Creative Commons Attribuzione-Condividi allo stesso
              modo 4.0. Si richiede di citare la fonte come segue: © The
              International Dysphagia Diet Standardisation Initiative 2019 @
              https://iddsi.org/ Concesso in licenza secondo la licenza Creative
              Commons Attribuzione Condividi allo stesso modo 4.0
              https://creativecommons.org/licenses/by-sa/4.0/legalcode . Non
              sono consentite opere derivate che vadano oltre la traduzione
              linguistica.
            </Paragraph>
          </Typography>
        </div>
      </div>
    </Space>
  );
};

export default Dashboard;
